(function () {
    'use strict';

    angular
        .module('core.services')
        .service('SharedDataService', SharedDataService)

    /** @ngInject */
    function SharedDataService(HttpService) {
        const SharedDataService = {
            getAll
        }

        return SharedDataService;

        function getAll() {
            return HttpService.get('/shared-data');
        }
    }
}());